import { TypedUseSelectorHook, useSelector as reduxSelector, useStore as useReduxStore } from 'react-redux';
import { Store } from 'redux';

import { AppOnboardingModalState } from '@/components/AppOnboarding/redux/slice';
import { MembersOnlyWarningModalState } from '@/components/MembersOnlyWarningModal/redux/types';
import { ProductsPromptModalState } from '@/components/products/ProductsPromptModal/redux/types';
import { TermsState } from '@/components/TermsAndConditions/redux/types';
import { Habitat, HabitatListItem } from '@/queries/habitats/types';
import type { HabitatCardsMobileStates } from '@/routes/habitat/components/CardTabs/Mobile/slice';

import { DeviceSettingsState } from './slices/deviceSettings/types';
import type { GuidedTourState } from './slices/guidedTour';
import MyAlbumState from './slices/myAlbum/types';
import { RemoteConfigState } from './slices/remoteConfig/types';
import type { SettingsState } from './slices/settings';
import { UserState } from './slices/user/types';

export type AppState = {
  user: UserState;
  guidedTour: GuidedTourState;
  settings: SettingsState;
  deviceSettings: DeviceSettingsState;
  myAlbum: MyAlbumState;
  remoteConfig: RemoteConfigState;
  habitat: {
    mobileCards: HabitatCardsMobileStates;
    habitatInfo: Habitat & { [key: string]: any };
    [key: string]: any;
  };
  modals: {
    membersOnlyWarningModal: MembersOnlyWarningModalState;
    appOnboardingModal: AppOnboardingModalState;
    productsPromptModal: ProductsPromptModalState;
    terms: TermsState;
    [key: string]: any;
  };

  // type only slice, not yet migrated
  allHabitats: HabitatListItem[];

  // others non migrated slices
  [slice: string]: any;
};

export const useSelector: TypedUseSelectorHook<AppState> = reduxSelector;
export const useStore: () => Store<AppState> = useReduxStore;
